import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { ASSET_READ } from 'utils/privileges';
import AssetEditor from 'screens/AssetEditor';
import NewLinkModal from 'screens/NewLinkModal';
import AddPlaylistManager from 'screens/PlaylistAddManager';
import AssetPickerModal from 'screens/AssetPickerModal';
import SectionEditorModalUi from 'screens/SectionEditorModalUi';
import { jsx as _jsx } from "react/jsx-runtime";
export function AddContentModals(_ref) {
  var reducerState = _ref.reducerState,
    initialPlaylistData = _ref.initialPlaylistData,
    renderCustomAssetPicker = _ref.renderCustomAssetPicker;
  var _reducerState = _slicedToArray(reducerState, 2),
    _reducerState$ = _reducerState[0],
    newContentTarget = _reducerState$.newContentTarget,
    content = _reducerState$.content,
    dispatch = _reducerState[1];
  var cancelAddContentProcess = function cancelAddContentProcess() {
    return dispatch({
      type: 'CANCEL_REQUEST_NEW_CONTENT'
    });
  };
  if (!newContentTarget) {
    return null;
  }
  var rank = newContentTarget.rank,
    parentId = newContentTarget.parentId;
  if (newContentTarget.variant === 'existing-content') {
    if (renderCustomAssetPicker) {
      return renderCustomAssetPicker({
        reducerState: reducerState,
        initialPlaylistData: initialPlaylistData
      });
    }
    var handleAddAssets = function handleAddAssets(_ref2) {
      var toAdd = _ref2.toAdd;
      dispatch({
        type: 'ADD_CONTENT',
        targetRankInSection: rank,
        targetParentId: parentId,
        data: toAdd
      });
    };

    // Only pass on content that is of type `asset` to the AssetPickerModal
    var assetContent = content.filter(function (contentItem) {
      return contentItem.type !== 'playlist' && contentItem.type !== 'section';
    }
    // Cast items to PlaylistContent as AssetPickerModal only needs to access item.id
    // Should look into simplifying `ItemPicker` to take `disabledItemIds` instead.
    );
    return /*#__PURE__*/_jsx(AssetPickerModal, {
      onSubmit: handleAddAssets,
      onClose: cancelAddContentProcess,
      disabledItems: assetContent,
      owner: "local_and_common",
      privilege: ASSET_READ,
      getFullData: true
    });
  }
  if (newContentTarget.variant === 'existing-playlist') {
    var handleAddPlaylists = function handleAddPlaylists(playlistsToAdd) {
      dispatch({
        type: 'ADD_CONTENT',
        targetRankInSection: rank,
        targetParentId: parentId,
        data: playlistsToAdd
      });
    };

    // Only pass on content that is of type `playlist` to the AddPlaylistManager
    var playlistContent = content.filter(function (contentItem) {
      return contentItem.type === 'playlist';
    }
    // Cast items to PlaylistContent as PlaylistPickerModal only needs to access item.id
    // Should look into simplifying `ItemPicker` to take `disabledItemIds` instead.
    );
    return /*#__PURE__*/_jsx(AddPlaylistManager, {
      playlist: initialPlaylistData,
      onSubmit: handleAddPlaylists,
      onClose: cancelAddContentProcess,
      disabledItems: playlistContent,
      getFullData: true
    });
  }
  if (newContentTarget.variant === 'new-weblink') {
    var handleAddWebLink = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: 'ADD_CONTENT',
                targetRankInSection: rank,
                targetParentId: parentId,
                data: data
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleAddWebLink(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    return /*#__PURE__*/_jsx(NewLinkModal, {
      onClose: cancelAddContentProcess,
      parentPlaylist: initialPlaylistData,
      onSubmit: handleAddWebLink,
      inContentManagerContext: true
    });
  }
  if (newContentTarget.variant === 'new-content' || newContentTarget.variant === 'new-event') {
    var handleAddNewAsset = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
        var changes;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              changes = _ref4.changes;
              dispatch({
                type: 'ADD_CONTENT',
                targetRankInSection: rank,
                targetParentId: parentId,
                data: changes
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleAddNewAsset(_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
    return /*#__PURE__*/_jsx(AssetEditor, {
      parentPlaylist: initialPlaylistData,
      onSubmit: handleAddNewAsset,
      onClose: cancelAddContentProcess,
      onSelectAsset: function onSelectAsset() {
        return dispatch({
          type: 'REQUEST_NEW_CONTENT',
          variant: 'existing-content',
          targetParentId: parentId,
          targetRankInSection: rank
        });
      },
      inContentManagerContext: true,
      isNewEvent: newContentTarget.variant === 'new-event'
    });
  }
  if (newContentTarget.variant === 'new-section') {
    var handleAddNewSection = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(changes) {
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              dispatch({
                type: 'ADD_SECTION',
                targetRankInSection: rank,
                targetParentId: parentId,
                data: _objectSpread({}, changes)
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function handleAddNewSection(_x3) {
        return _ref6.apply(this, arguments);
      };
    }();
    return /*#__PURE__*/_jsx(SectionEditorModalUi, {
      onSubmit: handleAddNewSection,
      onClose: cancelAddContentProcess,
      inContentManagerContext: true,
      isSubsection: newContentTarget.parentId !== undefined
    });
  }
  return null;
}